import { useBuilderContext } from "@Context/game/builder/builder-context";
import { ImportFormat } from "@Enums/ImportFormat";
import { isNull } from "lodash-es";
import { ChangeEvent, useEffect, useRef } from "react";
import { getScenarioStateFromData, loadScenario } from "../functions/scenario-functions";
import { StateChangeSource } from "../models/builder-data-types";

const ScenarioImporter = ({ onError = () => {} }: { onError?: (error: string) => void }) => {
  const { state, dispatch } = useBuilderContext();
  const scenarioFileSelector = useRef<HTMLInputElement>(null);

  const handleScenarioChanged = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files === null) {
      console.error("Files are null");
      finishImport();
      return;
    }
    const file = event.target.files[0];
    if (file === undefined) {
      console.error("File is undefined");
      finishImport();
      return;
    }
    doImportFile(file);
  };

  const doImportFile = (file: File | null) => {
    if (isNull(file)) {
      console.error("File is null");
      finishImport();
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target !== null && e.target.result !== null) {
        const scenarioData = JSON.parse(e.target.result as string);
        const scenarioState = getScenarioStateFromData(scenarioData, state.field, []);
        loadScenario(scenarioState, StateChangeSource.Edit, state, dispatch);
        finishImport();
      }
    };
    reader.readAsText(file);
  };

  const finishImport = () => {
    if (scenarioFileSelector.current !== null) scenarioFileSelector.current.value = "";
    dispatch({ importFormat: ImportFormat.NONE });
  };

  useEffect(() => {
    if (state.showImportDialog && scenarioFileSelector.current !== null) {
      onError("");
      scenarioFileSelector.current.value = "";
      scenarioFileSelector.current.click();
    }
  }, [state.showImportDialog]);

  return <input type="file" accept=".txt,.json" ref={scenarioFileSelector} style={{ display: "none" }} onChange={handleScenarioChanged} />;
};

export default ScenarioImporter;
